import { BrandIcon } from "./brand-icon.tsx"

export const ConnectionSymbol = ({ state = "brand" }: { readonly state?: "brand" | "success" | "pending" | "error" }) => (
  <span aria-hidden="true" className={`connection-symbol connection-symbol-${state}`}>
    {state === "brand" ? <BrandIcon size={64} /> : (
      <svg aria-hidden="true" fill="none" viewBox="0 0 24 24">
        <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
          {state === "success" ? <path d="m5 12 4 4L19 6" /> : state === "error" ? <><path d="M12 5v9" /><circle cx="12" cy="19" r="0.5" /></> : <><circle cx="12" cy="12" r="9" /><path d="M12 6v6l4 2" /></>}
        </g>
      </svg>
    )}
  </span>
)
